<template>
    <div class="col dashboard__dates">
        <div class="box box--dark-green" v-bind:class="{pending: pending}">
            <div class="row">
                <div class="col-lg-4">
                    <h2 class="h h--2 dashboard__dates-h2">Szkolenia online</h2>
                    <router-link :to="{name: 'OnlineTraining'}" class="button button--small button--fixed-width">Zobacz listę &raquo;</router-link>
                </div>
                <div class="col-lg-8">
                    <h3 class="dashboard__dates-subheader" style="line-height: 2">Weź udział w szkoleniach online w dogodnym dla siebie terminie, wypełnij testy, zdobądź punkty i{{'\xa0'}}zostań <b>Certyfikowanym Instalatorem</b>!</h3>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'WebinarWidget',
  data () {
    return {
      pending: true,
      // events: []
    }
  },
  created() {
    let vm = this;
    vm.pending = false;
    // let vm = this;
    // Vue.axios({
    //   method: 'get',
    //   url: '/events',
    //   params: {
    //     pagination: 2,
    //     from_start_date: new Date()
    //   }
    // })
    // .then(response => {
    //   vm.pending = false
    //   vm.events = response.data.data.events
    // })
    // .catch(error => {
    //   vm.pending = false
    // })
  }
}
</script>



// WEBPACK FOOTER //
// src/app/home/webinar/WebinarWidget.vue